// extracted by mini-css-extract-plugin
export var bgGradientEvents1 = "eventCard-module--bgGradientEvents1--9134a";
export var bgGradientEvents2 = "eventCard-module--bgGradientEvents2--d43e0";
export var bgGradientEvents3 = "eventCard-module--bgGradientEvents3--13a84";
export var cardBody = "eventCard-module--cardBody--283af";
export var cardDate = "eventCard-module--cardDate--29fe5";
export var cardFooter = "eventCard-module--cardFooter--1c252";
export var cardHeader = "eventCard-module--cardHeader--27ccc";
export var cardTitle = "eventCard-module--cardTitle--8ffe7";
export var eventCard = "eventCard-module--eventCard--92cc9";